/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diff_Ex_IntroInputs */

const en_diff_ex_intro = /** @type {(inputs: Diff_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One value changed, one key was removed, and one key was added.`)
};

const ko_diff_ex_intro = /** @type {(inputs: Diff_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`값 하나가 바뀌고, 키 하나가 제거되고, 키 하나가 추가되었습니다.`)
};

const ja_diff_ex_intro = /** @type {(inputs: Diff_Ex_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`値が 1 つ変わり、キーが 1 つ削除され、キーが 1 つ追加されました。`)
};

/**
* | output |
* | --- |
* | "One value changed, one key was removed, and one key was added." |
*
* @param {Diff_Ex_IntroInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const diff_ex_intro = /** @type {((inputs?: Diff_Ex_IntroInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diff_Ex_IntroInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_diff_ex_intro(inputs)
	if (locale === "ko") return ko_diff_ex_intro(inputs)
	return ja_diff_ex_intro(inputs)
});